// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__193MU","title":"AfterBackImages_title__mGy3j","images":"AfterBackImages_images__1QSwA"};